export const TYPES = {
  CARER: 'carer',
  USER: 'user',
}
